import { render, staticRenderFns } from "./TailwindAddMoreColors.vue?vue&type=template&id=0dd9b96e&"
import script from "./TailwindAddMoreColors.vue?vue&type=script&lang=js&"
export * from "./TailwindAddMoreColors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports